import React, { useState } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

import { Tooltip } from '../../../components/_reusable/Tooltip/Tooltip';
import { DatePickerField, FIELD_STYLE_OUTLINED } from '../../../components/_reusable/Input/Input';

const FIXED_MIN = moment('20000101');
const FIXED_MAX = moment();

const DateRange = ({ curr, onChange }) => {
  const [temp, setTemp] = useState({ from: null, to: null });

  const updateRange = (which, val) => {
    setTemp({ ...temp, [which]: val });
  };

  const applyRange = () => {
    let { from, to } = temp;

    if (!from || !to) { return; }

    onChange({
      from: from.startOf('day').unix(),
      to: to.endOf('day').unix(),
    });
  };

  const resetRange = () => {
    setTemp({ from: null, to: null });
    onChange(null);
  };

  return (
    <div className="option-date-range">
      <DatePickerField
        id="history-creation-from"
        fieldStyle={FIELD_STYLE_OUTLINED}
        label="Od"
        value={temp.from || null}
        onChange={date => updateRange('from', date)}
        disabled={!!curr.from}
        maxDate={temp.to ? temp.to : FIXED_MAX}
        variant="inline"
        disableToolbar
      />

      <span className="option-date-range-divider">-</span>

      <DatePickerField
        id="history-creation-to"
        fieldStyle={FIELD_STYLE_OUTLINED}
        label="Do"
        value={temp.to || null}
        onChange={date => updateRange('to', date)}
        disabled={!!curr.to || !temp.from}
        minDate={temp.from ? temp.from : FIXED_MIN}
        variant="inline"
        disableToolbar
      />

      { (curr && curr.from && curr.to )
        ? (
          <Tooltip title="Poništi">
            <span 
              className="gt-icon gt-icon-close-circle"
              role="button"
              onClick={resetRange}
            />
          </Tooltip>
        )
        : (
          <Tooltip title="Potvrdi">
            <span 
              className="gt-icon gt-icon-right-arrow"
              role="button"
              onClick={applyRange}
            />
          </Tooltip>
        )
      }
    </div>
  );
};

DateRange.propTypes = {
  curr: PropTypes.shape({
    from: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    to: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  onChange: PropTypes.func,
};

DateRange.defaultProps = {
  curr: { from: null, to: null },
  onChange: f => f,
};

export { DateRange };
